import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SharedDirectivesModule } from 'src/directives/shared-directives.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { KnowledgeGapInsightDetailComponent } from './knowledge-gap-insight-detail/knowledge-gap-insight-detail.component';
import { KnowledgeGapTopicDetailComponent } from './knowledge-gap-topic-detail/knowledge-gap-topic-detail.component';
import { KnowledgeGapsTenantInsightsComponent } from './knowledge-gaps-tenant-insights/knowledge-gaps-tenant-insights.component';
import { SuperAdminKnowledgeGapsRoutingModule } from './super-admin-knowledge-gaps-routing.module';
import { SuperAdminKnowledgeGapsTenantSelectionComponent } from './super-admin-knowledge-gaps-tenant-selection.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    SharedDirectivesModule,
    SharedPipesModule,
    SuperAdminKnowledgeGapsRoutingModule,
  ],
  declarations: [
    SuperAdminKnowledgeGapsTenantSelectionComponent,
    KnowledgeGapsTenantInsightsComponent,
    KnowledgeGapInsightDetailComponent,
    KnowledgeGapTopicDetailComponent,
  ],
})
export class SuperAdminKnowledgeGapsModule {}
